// extracted by mini-css-extract-plugin
module.exports = {"root":"ListBlockEditor_root__CFpRh","orderedToggle":"ListBlockEditor_orderedToggle__UQLWx"};